var Layout = /* @__PURE__ */ ((Layout2) => {
  Layout2[Layout2["Cards"] = 0] = "Cards";
  Layout2[Layout2["Rows"] = 1] = "Rows";
  return Layout2;
})(Layout || {});
export {
  Layout as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGF5b3V0LmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL0xheW91dC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJlbnVtIExheW91dCB7XG4gIENhcmRzLFxuICBSb3dzLFxufVxuXG5leHBvcnQgZGVmYXVsdCBMYXlvdXQ7XG4iXSwibmFtZXMiOlsiTGF5b3V0Il0sIm1hcHBpbmdzIjoiQUFBSyxJQUFBLDJCQUFBQSxZQUFMO0FBQ0VBLFVBQUEsUUFBQSxPQUFBLElBQUEsQ0FBQSxJQUFBO0FBQ0FBLFVBQUEsUUFBQSxNQUFBLElBQUEsQ0FBQSxJQUFBO0FBRkdBLFNBQUFBO0FBQUEsR0FBQSxVQUFBLENBQUEsQ0FBQTsifQ==
